import { render, staticRenderFns } from "./CommodityAnalysisSelectors.vue?vue&type=template&id=03c8af1e&"
import script from "./CommodityAnalysisSelectors.vue?vue&type=script&lang=js&"
export * from "./CommodityAnalysisSelectors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports